export default __webpack_public_path__ + "static/media/Rectangles_08.1e3c14bd.png";